import { Component, Input, Output, OnChanges, EventEmitter, OnInit, OnDestroy, inject } from '@angular/core';
import { PatientAttachment } from '../../../core/models/patient-attachment.model';
import { Capture } from '../../../core/models/capture.model';
import { CaptureValidationService, ValidationKeys } from '../../../core/services/capture-validation.service';
import { CaptureService } from 'app/core/services/capture.service';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-associate-patient-document',
    templateUrl: './associate-patient-document.component.html',
    styleUrls: ['./associate-patient-document.component.scss'],
    imports: [FormsModule, NgClass]
})
export class AssociatePatientDocumentComponent implements OnInit, OnDestroy, OnChanges {
  private captureValidationService = inject(CaptureValidationService);
  private captureService = inject(CaptureService);

  @Input() capture: Capture;
  @Input() selectedAttachment: PatientAttachment;

  @Output()
  associatedAttachmentChange = new EventEmitter<{ isAssociated: boolean; patientAttachment: PatientAttachment }>();

  isAssociated = false;
  canReadyToVerify = false;
  disabled = false;
  captureChangedSubscription = null;

  ngOnInit(): void {
    this.captureChangedSubscription = this.captureService.captureChanged.subscribe(
      ({ capture }) => {
        this.capture = capture;
        this.updateFlags();
      }
    );
  }

  ngOnDestroy(): void {
    if (this.captureChangedSubscription) {
      this.captureChangedSubscription.unsubscribe();
    }
  }

  ngOnChanges() {
    this.updateFlags();
  }

  onPatientAttachmentAssociatedChanged($event) {
    $event.preventDefault();
    this.associatedAttachmentChange.emit({
      isAssociated: this.isAssociated,
      patientAttachment: this.selectedAttachment,
    });
  }

  get errorMessage() {
    return this.captureValidationService.getError(ValidationKeys.selectedPatientAttachment);
  }

  private updateFlags() {
    this.isAssociated = this.capture.verifyingPatientAttachmentId === this.selectedAttachment.id;
    this.canReadyToVerify = this.isAssociated && this.capture.hasPatientAttachmentThatCanReadyToVerify;
    this.disabled = this.capture.frozen || this.selectedAttachment.markedAsInvalid || this.canReadyToVerify;
  }
}
